module.exports = __webpack_public_path__ + "static/csc-fc3799fd39e36f5b95b8464f7b4b5d4b.png";